package com.zaurh.mapquizwebsite.di

import com.zaurh.mapquizwebsite.data.repository.AuthRepositoryImpl
import com.zaurh.mapquizwebsite.data.repository.DailyRewardsRepositoryImpl
import com.zaurh.mapquizwebsite.data.repository.UserRepositoryImpl
import com.zaurh.mapquizwebsite.data.service.AuthApi
import com.zaurh.mapquizwebsite.data.service.DailyRewardsApi
import com.zaurh.mapquizwebsite.data.service.UserApi
import com.zaurh.mapquizwebsite.domain.repository.AuthRepository
import com.zaurh.mapquizwebsite.domain.repository.DailyRewardsRepository
import com.zaurh.mapquizwebsite.domain.repository.UserRepository
import com.zaurh.mapquizwebsite.presentation.screen.daily_reward.DailyRewardsViewModel
import com.zaurh.mapquizwebsite.presentation.screen.main.MainViewModel
import com.zaurh.mapquizwebsite.utils.PreferencesManager
import com.zaurh.mapquizwebsite.utils.provideSettings
import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.plugins.websocket.WebSockets
import io.ktor.client.request.header
import io.ktor.http.HttpHeaders
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import org.koin.core.qualifier.named
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

val appModule = module {
    single {
        Json {
            ignoreUnknownKeys = true
            classDiscriminator = "type"
            isLenient = true
            encodeDefaults = true
        }
    }

    single {
        val preferencesManager: PreferencesManager = get()

        HttpClient(Js) {
            install(ContentNegotiation) {
                json(get())
            }

            defaultRequest {
//                url("http://localhost:8081/")
                url("https://mapquiz.zaurhasanov.com/")
                header(HttpHeaders.Accept, "application/json")

                val token = preferencesManager.getJwtToken()

                token?.let {
                    header(
                        HttpHeaders.Authorization,
                        "Bearer $it"
                    )
                }
            }
        }
    }

    single { provideSettings() }

    single { PreferencesManager(get()) }

    single<UserRepository> {
        UserRepositoryImpl(get())
    }

    single<AuthRepository> {
        AuthRepositoryImpl(get())
    }

    single<DailyRewardsRepository> {
        DailyRewardsRepositoryImpl(get())
    }

    single {
        UserApi(get())
    }

    single {
        AuthApi(get())
    }

    single {
        DailyRewardsApi(get())
    }

    viewModel {
        MainViewModel(get(), get(), get())
    }

    viewModel {
        DailyRewardsViewModel(get())
    }
}